<template>
  <el-drawer
    :visible.sync="visible"
    :title="role ? role.name : ''"
    direction="rtl"
    size="520px"
    :append-to-body="true"
    @open="handlerOpen"
    @closed="handlerClosed"
  >
    <div class="role-access" v-loading="loadingForm" :element-loading-text="$t('common.request')">
      <div class="role-access__hint">{{ $t('teamHub.accessHint') }}</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="authFilter">
            <el-input :placeholder="$t('roleAuth.pAuthFilter')" size="small" :clearable="true" v-model="authFilterText"></el-input>
          </div>
          <el-tree
            :data="menuList"
            ref="authTree"
            accordion
            :expand-on-click-node="true"
            :show-checkbox="true"
            node-key="id"
            :check-strictly="true"
            :filter-node-method="authFilterNode"
            @node-click="menuNodeClick"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="data.type === 0">（{{ $t('roleAuth.mq') }}）</span>
              <span v-if="data.type === 1">（{{ $t('roleAuth.mw') }}）</span>
              <span v-if="data.type === 2">（{{ $t('roleAuth.me') }}）</span>
            </span>
          </el-tree>
        </el-col>
        <el-col :span="12">
          <span class="role-access__actions">
            <el-button type="primary" icon="el-icon-folder-checked" size="small" @click="reset">{{ $t('roleAuth.reset') }}</el-button>
            <el-button type="success" icon="el-icon-guide" size="small" :disabled="loadingForm" @click="assignAuthority">{{
              $t('roleAuth.assign')
            }}</el-button>
          </span>
          <vue-scroll>
            <div class="power" style="max-height: 550px">
              <div v-for="item in listPower" :key="item.id" class="list-power">
                <div class="power-title">
                  {{ item.name }}
                  <el-button v-if="item.children && item.children.length > 0" @click="handleCheckAllChange(item.id)" type="text">{{
                    $t('roleAuth.check')
                  }}</el-button>
                </div>
                <el-checkbox-group v-model="power" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in item.children" :label="city.id" :key="city.id">{{ city.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </vue-scroll>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
// 角色→菜单/操作授权：逻辑来自 RoleAuth.vue，去掉左侧"选角色"树（角色由外部 prop 指定）
export default {
  name: 'RoleAccessDrawer',
  props: {
    visible: { type: Boolean, default: false },
    role: { type: Object, default: null }
  },
  data() {
    return {
      authFilterText: '',
      menuList: [],
      listPower: [],
      power: [],
      loadingForm: false,
      menuLoaded: false
    };
  },
  watch: {
    authFilterText(val) {
      this.$refs.authTree.filter(val);
    }
  },
  methods: {
    handlerOpen() {
      this.power = [];
      if (!this.menuLoaded) {
        this.loadMenu().then(() => {
          this.loadRoleMenu();
        });
      } else {
        this.loadRoleMenu();
      }
    },
    handlerClosed() {
      this.$emit('close');
    },
    // 菜单目录 外两层 + 权限 里两层（与 RoleAuth.vue 的 loadMenu 一致）
    loadMenu() {
      return this.$api.request(this.$url.AuthorityRoleMenu.load).then(res => {
        if (res.code === 0) {
          const menuList = JSON.parse(JSON.stringify(res.data));
          menuList.forEach(item => {
            if (item.children && item.children.length > 0) {
              item.children.forEach(child => {
                delete child.children;
              });
            }
          });
          this.menuList = menuList;
          let listPower = [];
          res.data.forEach(item => {
            if (item.children && item.children.length > 0) {
              listPower = [...listPower, ...item.children];
            }
          });
          this.listPower = listPower;
          this.menuLoaded = true;
        }
      });
    },
    // 加载该角色已授权的菜单/操作 id（与 RoleAuth.vue 的 roleNodeClick 一致）
    loadRoleMenu() {
      if (!this.role || !this.role.id) {
        return;
      }
      this.$api
        .request(this.$url.AuthorityRoleMenu.listMenu, this.$method.get, { roleId: this.role.id })
        .then(res => {
          if (res.code === 0) {
            const checkedKeys = res.data;
            this.$nextTick(() => {
              if (this.$refs.authTree) {
                this.$refs.authTree.setCheckedKeys(checkedKeys);
              }
            });
            const ids = [];
            this.listPower.forEach(item => {
              if (item.children && item.children.length > 0) {
                item.children.forEach(m => {
                  ids.push(m.id);
                });
              }
            });
            this.power = this.getArrayIntersection(checkedKeys, ids);
          }
        });
    },
    getArrayIntersection(array1, array2) {
      const set1 = new Set(array1);
      return array2.filter(value => set1.has(value));
    },
    menuNodeClick(data) {
      if (data.children) return;
      for (let i = 0; i < this.listPower.length; i++) {
        if (this.listPower[i].id === data.id) {
          const info = this.listPower[i];
          this.listPower.splice(i, 1);
          this.listPower.unshift(info);
          break;
        }
      }
    },
    handleCheckAllChange(val) {
      this.listPower.forEach(key => {
        if (key.id === val) {
          key.children.forEach(m => {
            if (!this.power.includes(m.id)) {
              this.power.push(m.id);
            }
          });
          return false;
        }
      });
    },
    handleCheckedCitiesChange(value) {},
    authFilterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    reset() {
      this.$refs.authTree.setCheckedKeys([]);
      this.power = [];
    },
    // 保存：与 RoleAuth.vue 的 assignAuthority 一致的 payload（{ id, menuIds }）与确认流程
    assignAuthority() {
      if (!this.role || !this.role.id) {
        return;
      }
      const auth = this.$refs.authTree.getCheckedNodes(false, true);
      this.$confirm(this.$t('roleAuth.isRole'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.definite'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        const menuIds = this.$cloud.getIds(auth).concat(this.power);
        const obj = { id: this.role.id, menuIds: menuIds };
        this.loadingForm = true;
        this.$api
          .request(this.$url.AuthorityRoleMenu.save, this.$method.post, obj)
          .then(res => {
            if (res.code === 0) {
              this.$notify({ title: this.$t('common.tip'), message: this.$t('roleAuth.upAuth'), type: 'success' });
              this.$emit('saved');
            }
            this.loadingForm = false;
          })
          .catch(() => {
            this.loadingForm = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.role-access {
  padding-bottom: 30px;

  &__hint {
    color: var(--vtm-ink-2);
    font-size: 12.5px;
    margin-bottom: 14px;
    padding: 0 4px;
  }

  &__actions {
    margin-bottom: 15px;
    display: block;
  }

  .power {
    color: var(--vtm-ink-2);
  }

  .list-power {
    margin-bottom: 10px;
  }

  .power-title {
    margin-bottom: 5px;

    .el-button--text {
      margin-left: 10px;
    }
  }
}
</style>
